<template>
    <div class="row">
		<div class="col-xl-12">
			<div>
				<card title="Calendar">
                    <loader :loading="loading_calendar">
                    <div class="row mb-3">
						<div class="col-xl-3 col-lg-4">
                            <label>Month</label>
							<select class="form-control" v-model="date.month" @change="onChangeDate">
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>
						</div>
                        <div class="col-xl-3 col-lg-4">
                            <label>Year</label>
							<select class="form-control" v-model="date.year" @change="onChangeDate">
                                <option v-for="y in years" :value="y.year" :key="y.year">{{y.year}}</option>
                            </select>
						</div>
                        <div class="col-xl-3 col-lg-4">
                            <label>Department</label>
							<select class="form-control" v-model="selected_department" @change="onChangeDepartment">
                                <option :value="0">All</option>
                                <option v-for="d in departments" :value="d.id_department" :key="d.id_department">{{d.name}}</option>
                            </select>
						</div>
                        <div class="col-xl-3 col-lg-4">
                            <label>Employee</label>
							<select class="form-control" v-model="selected_employee" @change="onChangeEmployee">
                                <option :value="0">All</option>
                                <option v-for="e in employees" :value="e.id_employee" :key="e.id_employee">{{e.first_name+' '+e.last_name}}</option>
                            </select>
						</div>
					</div>
                    <div class="row">
						<div class="col-12">
                            
                            <FullCalendar ref="fullCalendar"
                               
                                defaultView="dayGridMonth"
                                :plugins="calendarPlugins"
                                :events="events"
                                :firstDay="1"
                                @eventClick="handleEventClick"
                                @dateClick="handleDateClick"
                                :header="{
                                    left: '',
                                    center: '',
                                    right: ''
                                }"
                            />
                           
                        </div>
                    </div>
                     </loader>
				</card>
			</div>
		</div>
    </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { months } from 'moment'

export default {
    components:{
        FullCalendar
    },
    data(){
        return{
            date:{
                month:this.$moment().month()+1,
                year:this.$moment().year(),
            },
            years:[],
            departments:[],
            employees:[],
            selected_department:0,
            selected_employee:0,
            loading_calendar:true,
            calendarPlugins:[dayGridPlugin,interactionPlugin],
            events:[]
        }
    },
    methods:{
        handleDateClick(arg) {
            let date = this.$moment(arg.date).format('YYYY-MM-DD');
            let calendarApi = this.$refs.fullCalendar.getApi();
            let event = calendarApi.getEventById(date);
            if(this.selected_employee!==0 && event!==null){
                this.$router.push('/dashboard/'+this.selected_employee+'/'+date);
            }
        },
        handleEventClick(info){
            if(this.selected_employee!==0){
                let date = this.$moment(info.event.start).format('YYYY-MM-DD');
                this.$router.push('/dashboard/'+this.selected_employee+'/'+date);
            }
        },
        async onChangeDate(){
            this.loading_calendar = true;
            await this.loadCalendar();
            await this.goToMonth();
            this.loading_calendar = false;
        },
        async onChangeDepartment(){
            this.loading_calendar = true;
            this.selected_employee = 0;
            await this.loadEmployees();
            await this.loadCalendar();
            await this.goToMonth();
            this.loading_calendar = false;
        },
        async onChangeEmployee(){
            this.loading_calendar = true;
            await this.loadCalendar();
            await this.goToMonth();
            this.loading_calendar = false;
        },
        async goToMonth(){
            let month = this.date.month.toString().length===1 ? '0'+this.date.month : this.date.month;
            let date = this.date.year+'-'+month+'-01';
            let calendarApi = this.$refs.fullCalendar.getApi();
            await calendarApi.gotoDate(date);
        },
        setColorDay(total_appointments,availability){
            let result = (availability/2);
            if(total_appointments>=availability){
                return 'red';
            }
            if(result>total_appointments){
                return 'green';
            }
            else{
                return 'yellow';
            }

        },
        getEaster(year) {
	        //let f = Math.floor;
		    // Golden Number - 1
		    let G = year % 19
	        let C = Math.floor(year / 100)
		    // related to Epact
		    let H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13)/25) + 19 * G + 15) % 30
		    // number of days from 21 March to the Paschal full moon
		    let I = H - Math.floor(H/28) * (1 - Math.floor(29/(H + 1)) * Math.floor((21-G)/11))
		    // weekday for the Paschal full moon
		    let J = (year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4)) % 7
		    // number of days from 21 March to the Sunday on or before the Paschal full moon
		    let L = I - J
            let month = 3 + Math.floor((L + 40)/44)
		    let day = L + 28 - 31 * Math.floor(month / 4);
            //return [month,day];
            return new Date(year+'-'+month+'-'+day);
        },
        async loadPublicHolidays(){

            let day_public_holiday=[
                [this.date.year+'-01-01',"New Year's\n Day"],
                [this.date.year+'-02-10',"Feast of Saint\nPaul's Shipwreck"],
                [this.date.year+'-03-19',"Saint Joseph's Day"],
                [this.date.year+'-03-31',"Freedom Day"],
                [this.$moment(this.getEaster(this.date.year)).add(-2,'days').format('YYYY-MM-DD'),"Good Friday"],
                [this.$moment(this.getEaster(this.date.year)).format('YYYY-MM-DD'),"Easter"],
                [this.date.year+'-05-01',"International\n Workers' Day"],
                [this.date.year+'-06-07',"Sette Giugno"],
                [this.date.year+'-06-29',"Feast of Saints\n Peter and Paul"],
                [this.date.year+'-08-15',"Assumption of Mary"],
                [this.date.year+'-09-08',"Victory Day"],
                [this.date.year+'-09-21',"Independence Day"],
                [this.date.year+'-12-08',"Feast of the\n Immaculate Conception"],
                [this.date.year+'-12-13',"Republic Day\nof Malta"],
                [this.date.year+'-12-25',"Christmas Day"]
            ];

            day_public_holiday.forEach(d => {
                this.events.push({
                    classNames:'public-holiday',
                    date:d[0],
                    title:d[1]
                })
            });
        },
        async loadCalendar(){
            //this.loading_calendar = true;
            this.events = [];
            let result = await this.$api.get('appointment/s/calendar/'+this.date.month+'/'+this.date.year+'/'+this.selected_department+'/'+this.selected_employee);
            let event = result.data.map(e=>{
                return{
                    id:e.date,
                    date:e.date,
                    title:e.total_appointments+' of '+e.availability,
                }
            })
            let background = result.data.map(e=>{
                return{
                    date:e.date,
                    rendering:'background',
                    backgroundColor:this.setColorDay(e.total_appointments,e.availability)
                }
            })
            event.forEach(element => {
                this.events.push(element);
            });
            background.forEach(element => {
                this.events.push(element)
            });
            await this.loadPublicHolidays();
            this.loading_calendar = false;
        },
        async loadYears(){
            let result = await this.$api.get('appointment/s/years');
            if(result.data.length>0){
                this.years.push.apply(this.years,result.data);
            }
            let found = this.years.find(y=>{
                return y.year == this.$moment().year()
            });
            if(!found){
                this.years.push({year:this.$moment().year()})
            }
        },
        async loadDepartments(){
            let result = await this.$api.get('department');
            this.departments = result.data;
        },
        async loadEmployees(){
            let result = await this.$api.get('employee?where=enabled=1&join=departments');
            this.employees = result.data;
            if(this.selected_department!==0){
				let found = this.employees.filter(e=>{
					return e.departments.find(d=>{
                        return d.id_department == this.selected_department;
					})
				});
				this.employees = found;
			}
        }
    },
    async beforeMount(){
        this.loading_calendar = true;
        await this.loadYears();
        await this.loadCalendar();
        await this.loadDepartments();
        await this.loadEmployees();
        await this.goToMonth();
        this.loading_calendar = false;
    }
}
</script>

<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

.fc-row .fc-content-skeleton td{
    border-bottom:1px solid #dedede !important;
}
.fc-event{
    background-color: transparent !important;
    border-color: transparent !important;
    padding-top:1.5rem;
    padding-left: 0.5rem;
    font-size: 20px;
}

.public-holiday .fc-content .fc-title{
    color: #fff;
    background-color: red;
    font-size: 15px;
}

</style>